import { bindActionCreators } from 'redux';
import { connect } from '../../../common/react-redux';
import { AddBankEntryModal as AddBankEntryModalPresenter } from './presenter';
import * as modalActions from '../../../common/actions/modal';
import { createBankItem } from '../../../common/actions/modifications';
import { interactionTypeFetch } from '../../../common/api/interactionTypes';
import { getModalTrigger } from '../../../common/util/modalHelpers';
import { ADD_BANK_ENTRY_MODAL } from '@instructure/quiz-common';
import { getInteractionTypes } from '../../../common/selectors/interactionTypes';
function mapStateToProps(state, props) {
  return {
    modalOpen: state.getIn(['modal', 'isOpen']) === ADD_BANK_ENTRY_MODAL,
    modalTrigger: getModalTrigger(state),
    interactionTypes: getInteractionTypes(state)
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: bindActionCreators(modalActions.closeModal, dispatch),
    createBankItem: bindActionCreators(createBankItem, dispatch),
    getInteractionTypes: bindActionCreators(interactionTypeFetch, dispatch)
  };
};
export var AddBankEntryModal = connect(mapStateToProps, mapDispatchToProps)(AddBankEntryModalPresenter);
export default AddBankEntryModal;